import { useTranslation } from 'react-i18next'

const TeenageRoom = (props) => {
  const { t } = useTranslation()
  
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="streetview-title"
      xmlSpace="preserve"
      {...props}
    >
      <title id="streetview-title">{t('antagonists:homophobicAdult:components:background')}</title>
      <defs>
        <clipPath id="a">
          <path
            style={{
              fill: 'none',
            }}
            d="M0 0h1920v1080H0z"
          />
        </clipPath>
        <clipPath id="b">
          <path
            style={{
              fill: '#284634',
            }}
            d="m1312.92 945.2.02-608.08 465.56-1.17 6.64 619.87-472.22-10.62z"
          />
        </clipPath>
        <clipPath id="c">
          <path
            style={{
              fill: '#1ea6b7',
            }}
            d="m-88.56 743.75-2.09-593.85 806.04-24.14 5.41 613.35-809.36 4.64z"
          />
        </clipPath>
      </defs>
      <g
        style={{
          clipPath: 'url(#a)',
        }}
      >
        <path
          style={{
            fill: '#eee5dc',
          }}
          d="M-214.6-99.22h2302v1214.71h-2302z"
        />
        <path
          style={{
            fill: '#c7d0d6',
          }}
          d="m-197.28 1414.55-14.15-697.94 2306.48 4.45 37.3 710.37-2329.63-16.88z"
        />
        <path
          style={{
            fill: '#c4af7d',
          }}
          d="m1290.57 936.81-3.46-697.89 517.34.23.58 707.65-514.46-9.99z"
        />
        <path
          style={{
            fill: '#284634',
          }}
          d="m1312.92 945.2.02-608.08 465.56-1.17 6.64 619.87-472.22-10.62z"
        />
        <g
          style={{
            clipPath: 'url(#b)',
          }}
        >
          <path
            style={{
              fill: '#5698c6',
            }}
            d="m1351.76 374.68.55 124.03 177.24 1.57-.93-124.1-176.86-1.5zm212.56 1.09.55 124.02 180.37-2.45-.93-124.11-179.99 2.54z"
          />
          <path
            style={{
              fill: '#c4af7d',
            }}
            d="m1544.11 325.55 3.69 684.94 6.15-1.31-4.92-687.57-4.92 3.94z"
          />
        </g>
        <path
          style={{
            fill: '#5698c6',
          }}
          d="m1349.43 510.62.42 292.38 179.92 1.94-.81-292.61-179.53-1.71zm215.34 2.34 1.28 290.35 181.96-1.62-3.94-288.95-179.3.22z"
        />
        <path
          style={{
            fill: '#c4af7d',
          }}
          d="m1633.16-289.19 1.54 447.21 295.12 2.13-.83-447.53-295.83-1.81z"
        />
        <path
          style={{
            fill: '#bbdfeb',
          }}
          d="m1653.09-267 1.95 395.42 255.9 1.95-1.3-395.74-256.55-1.63z"
        />
        <path
          style={{
            fill: '#bda979',
          }}
          d="m1779.43-269.5-5.54 409.59 15.18.54 4.68-410.29-14.32.16z"
        />
        <path
          style={{
            fill: '#c4af7d',
          }}
          d="m1278.95-290.05 1.54 447.21 295.12 2.12-.83-447.53-295.83-1.8z"
        />
        <path
          style={{
            fill: '#bbdfeb',
          }}
          d="m1298.88-267.87 1.95 395.42 255.9 1.96-1.3-395.75-256.55-1.63z"
        />
        <path
          style={{
            fill: '#bda979',
          }}
          d="m1425.22-270.37-5.53 409.59 15.17.54 4.68-410.29-14.32.16z"
        />
        <path
          style={{
            fill: '#c4af7d',
          }}
          d="m-106.76 956.46 1.96-805.8 846.04-2.69 5.69 817.12-853.69-8.63z"
        />
        <path
          style={{
            fill: '#1ea6b7',
          }}
          d="m-88.56 743.75-2.09-593.85 806.04-24.14 5.41 613.35-809.36 4.64z"
        />
        <g
          style={{
            clipPath: 'url(#c)',
          }}
        >
          <path
            d="M254.63 667s11.12-27.6 14.83-58.52c3.71-30.91 6.49-101.57 6.49-101.57l-4.63 2.21s-9.27 54.1-12.05 83.91c-2.78 29.81-9.27 72.87-9.27 72.87l4.63 1.1Z"
            style={{
              fill: '#1b9339',
            }}
          />
          <path
            d="M247.1 678.64s2.78-79.49 0-111.51c-2.78-32.02-4.63-52.99-4.63-52.99h-6.49s-3.71 33.12-1.85 66.24c1.85 33.12 7.41 100.47 7.41 100.47l5.56-2.21Z"
            style={{
              fill: '#008551',
            }}
          />
          <path
            d="m233.04 669.13-.31-2.16c-1.2-8.51-5.64-40.52-8.03-65.19-2.78-28.71-9.27-76.18-9.27-76.18l-4.63 1.1s0 36.43 5.56 72.87l11.12 72.87 5.56-3.31Zm12.74 6.54s9.27-80.6 12.97-133.59c3.71-52.99 9.27-92.74 9.27-92.74l-5.62-.5s-13.83 55.42-15.71 100.35c-1.89 44.93-3.77 120.57-3.77 120.57l2.86 5.91Z"
            style={{
              fill: '#1b9339',
            }}
          />
          <path
            style={{
              fill: '#e2a975',
            }}
            d="m271.63 674.16-1.37 37.11-42.92-1.01-.6-36.48-4.23-3.42-.07-8.38 52.76.29-.29 8.27-3.28 3.62z"
          />
          <path
            d="M326.4 519.44c-.63 0-1.06.65-.84 1.24 3 8.26 21.86 60.31 26.97 75.5 5.87 17.42 12.59 34.7 13.15 43.01.71 10.49-1.6 22.33-4.11 29.21-6.02 16.47-2.5 30.02-2.5 30.02l5.21-.21s-5-17.09 2.92-28.14 26.06-31.69 37.31-37.52c11.26-5.84 25.4-14.87 24.57-14.87s-1.11-2.95-1.11-2.95-16.37 12.4-24.08 15.95c-7.71 3.54-35.65 27.31-35.65 27.31s2.71-10.84 1.67-18.55c-1.04-7.71-11.05-33.98-14.38-44.19-3.34-10.21-27.88-75.48-27.88-75.48l-1.24-.31Z"
            style={{
              fill: '#008551',
            }}
          />
          <path
            d="M334.52 523.35s0-19.52-14.89-24.89c-14.89-5.37-20.12-2-22.21.24-4.43 4.77-5.61 8.05-5.61 8.05s4.85-3.68 11.2-.99c6.34 2.68 13.69 6.12 12.23 8.8-1.46 2.68-22.45-5.86-24.16-5.86s-5.86 3.17-8.05 7.08c-2.2 3.9-4.15 10.01-4.15 10.01s9.52-5.37 19.52-5.12c10.01.24 13.18 2.2 13.18 3.42s-14.4-.98-21.96 1.71c-7.56 2.68-9.52 3.66-10.49 6.59-.98 2.93-1.95 7.81-1.22 10.98.73 3.17 3.9 8.05 3.9 8.05s.98-7.08 11.71-12.93c10.74-5.86 20.5-5.37 22.21-3.66 1.71 1.71-8.54 4.88-16.35 8.3-7.81 3.42-13.18 11.96-13.18 11.96l8.54 6.83s.62-7.8 6.48-12.44 13.78-5.87 15.49-4.65c1.71 1.22-9.03 7.08-12.45 10.74s-4.64 7.32-4.64 7.32 6.34 2.59 8.54 5.27c2.2 2.68 5.37 7.42 5.37 7.42s.14-4.9 5.51-8.56 19.87-5.35 19.87-5.35 2.99-5.49.3-10.13c-2.68-4.64-6.89-12.08-3.48-13.54 3.42-1.46 8.3 4.64 9.52 9.76 1.22 5.12 1.32 11.14 1.32 11.14l15.27-8.7s-2.93-9.03-9.03-12.45-10.98-5.61-10.25-7.08 9.52-2.44 15.13 4.15c5.61 6.59 3.42 10.25 3.42 10.25s6.83-5.12 9.03-10.01c2.2-4.88 1.95-8.54 1.95-8.54s-5.12-2.2-11.47-6.59c-6.34-4.39-11.96-5.37-15.62-3.17s-10.49 6.59-10.49 6.59Z"
            style={{
              fill: '#008551',
            }}
          />
          <path
            d="M299.14 604.16s1.46-5.84-2.29-7.92-6.05-1.88-9.8.83c-3.75 2.71-5.63 12.72-10.42 16.89s-9.8 9.38-9.38 14.59c.42 5.21 2.54 10.19 2.54 10.19s2.26-3.77 5.18-4.71c6.47-2.08 23.34-9.65 27.92-13.61 4.59-3.96 13.95-12.63 7.5-18.34-3.7-3.28-11.26 2.08-11.26 2.08Z"
            style={{
              fill: '#007748',
            }}
          />
          <path
            d="M372.16 594.48s.42-6.46-7.92-5.21-14.59 8.96-10.21 16.47c4.38 7.5 8.58 10.16 9.62 12.25s2.11 3.16 2.11 3.16 1.09-1.17 3.09-2.67c3.13-2.35 18.45-9.3 19.49-17.22 1.04-7.92-4.71-9.69-8.67-10.32-3.96-.63-7.5 3.54-7.5 3.54Z"
            style={{
              fill: '#008551',
            }}
          />
          <path
            d="M301.89 607.16s13.47-5 24.37 5.91c10.91 10.91 27.16 44.94 27.16 44.94l4.43-.86s-21.45-40.03-32.03-48.62c-10.58-8.59-24.17-4.28-24.17-4.28l.24 2.91Z"
            style={{
              fill: '#007748',
            }}
          />
          <path
            d="M393.18 539.19s3.97-6.53 12.25-3.84c8.28 2.69 8.33 13.61 10.23 20.9 1.93 7.4-9.31 18.69-9.31 18.69s-.75-8.47-2.94-13.84c-2.27-5.55-5.02-7.25-6.17-6.72-1.15.54 1.69 4.13 3.59 7.69 1.9 3.56 3.38 11.76 3.38 11.76s-5.97 1.28-10.05 3.05c-2.83 1.23-7.47 4.61-9.56 5.36-1.65.59-4.17 3.09-4.17 3.09s.25-4.78-1.76-9.56c-1.68-3.98-9.7-14.76-11.69-21.55-2-6.79.98-14.97 6.05-20.14 5.08-5.18 9.2-7.7 13.84-6.45 6.15 1.65 6.33 11.56 6.33 11.56Z"
            style={{
              fill: '#008551',
            }}
          />
          <path
            d="M391.75 542.43s.78 38.04 5.39 55.52c4.61 17.48-9.6 32.65-12.75 51.1-3.16 18.45 1.1 50.63 1.1 50.63l-3.89-1.21s-3.96-33.14-2.01-48.68c1.94-15.54 19.5-36.06 15.13-51.84-4.37-15.78-5.83-55.36-5.83-55.36l2.87-.16Zm30.13 68.85s-.45-6.93 10.55-1.87c9.23 4.25 15.11 14.62 11.25 21.76-3.73 6.89-6.29 8.77-7.28 9.92-1 1.15-2.12 4.21-2.12 4.21s-1.44-1.74-5.03-3.4c-3.88-1.8-22.04-9.28-26.31-20.3-5.05-13.05 2.35-16.23 8.65-15.55 5.86.64 10.29 5.22 10.29 5.22Zm-49.52-9.37s-1.35 32.37-4.91 45.58c-3.71 13.78-7.21 25.69-8.69 33.69-1.78 9.6-3.71 17.96-3.71 17.96l3.64-.11s2.1-10.52 3.51-18.23c1.4-7.71 6.31-26.64 8.76-34.71 2.45-8.06 3.86-44.87 3.86-44.87l-2.45.7Z"
            style={{
              fill: '#008551',
            }}
          />
          <path
            style={{
              fill: '#e49a54',
            }}
            d="m344.36 667.91 4.12 45.14h40.38l4.36-42.29 4.48-.05.95-12.41-59.12.32.32 9.26 4.51.03z"
          />
          <path
            d="M499.02 487.06c-.73 0-1.23.75-.98 1.44 3.5 9.64 25.51 70.4 31.48 88.12 6.85 20.33 14.69 40.5 15.35 50.21.83 12.24-1.86 26.07-4.8 34.09-7.03 19.22-2.92 35.04-2.92 35.04l6.08-.24s-5.84-19.95 3.41-32.85c9.25-12.9 30.42-36.98 43.55-43.8 13.14-6.81 29.65-17.35 28.67-17.35s-1.29-3.45-1.29-3.45-19.11 14.48-28.11 18.61c-9 4.14-41.61 31.88-41.61 31.88s3.16-12.65 1.95-21.66c-1.22-9-12.9-39.66-16.79-51.58-3.89-11.92-32.54-88.1-32.54-88.1l-1.45-.36Z"
            style={{
              fill: '#008551',
            }}
          />
          <path
            d="M508.5 491.62s0-22.79-17.37-29.05c-17.37-6.27-23.49-2.33-25.92.28-5.17 5.57-6.55 9.4-6.55 9.4s5.66-4.29 13.07-1.16 15.98 7.14 14.28 10.27c-1.71 3.13-26.2-6.84-28.2-6.84s-6.84 3.7-9.4 8.26c-2.56 4.56-4.84 11.68-4.84 11.68s11.11-6.27 22.79-5.98c11.68.28 15.38 2.56 15.38 3.99s-16.81-1.14-25.64 1.99c-8.83 3.13-11.11 4.27-12.25 7.69-1.14 3.42-2.28 9.11-1.42 12.82.85 3.7 4.56 9.4 4.56 9.4s1.14-8.26 13.67-15.1 23.93-6.27 25.92-4.27c1.99 1.99-9.97 5.7-19.08 9.68-9.11 3.99-15.38 13.96-15.38 13.96l9.97 7.98s.72-9.1 7.56-14.52c6.84-5.41 16.08-6.85 18.07-5.42 1.99 1.42-10.54 8.26-14.53 12.53s-5.41 8.54-5.41 8.54 7.4 3.02 9.97 6.15c2.56 3.13 6.27 8.66 6.27 8.66s.16-5.72 6.43-9.99c6.27-4.27 23.2-6.24 23.2-6.24s3.49-6.41.35-11.83c-3.13-5.41-8.04-14.09-4.06-15.8 3.99-1.71 9.68 5.41 11.11 11.39 1.42 5.98 1.54 13 1.54 13l17.83-10.16s-3.42-10.54-10.54-14.53c-7.12-3.99-12.82-6.55-11.96-8.26s11.11-2.85 17.66 4.84c6.55 7.69 3.99 11.96 3.99 11.96s7.98-5.98 10.54-11.68c2.56-5.7 2.28-9.97 2.28-9.97s-5.98-2.56-13.39-7.69c-7.41-5.13-13.96-6.27-18.23-3.7s-12.25 7.69-12.25 7.69Zm-15.29 109.61s1.7-6.81-2.68-9.25c-4.38-2.43-7.06-2.19-11.44.97s-6.57 14.84-12.17 19.71c-5.6 4.87-11.44 10.95-10.95 17.03.49 6.08 2.97 11.89 2.97 11.89s2.64-4.41 6.05-5.5c7.55-2.42 27.24-11.26 32.59-15.88 5.35-4.62 16.28-14.74 8.76-21.41-4.32-3.83-13.14 2.43-13.14 2.43Zm59.22-26.57s.49-7.54-9.25-6.08c-9.73 1.46-17.03 10.46-11.92 19.22 5.11 8.76 10.01 11.86 11.23 14.3s2.46 3.69 2.46 3.69 1.27-1.37 3.61-3.12c3.66-2.74 21.53-10.85 22.75-20.1 1.22-9.25-5.49-11.32-10.12-12.05-4.62-.73-8.76 4.14-8.76 4.14Z"
            style={{
              fill: '#008551',
            }}
          />
          <path
            d="M498.65 601.6s15.72-5.84 28.45 6.9c12.73 12.73 31.7 52.45 31.7 52.45l5.17-1s-25.04-46.72-37.38-56.76c-12.35-10.03-28.21-5-28.21-5l.28 3.4Z"
            style={{
              fill: '#008551',
            }}
          />
          <path
            d="M608.31 515.33s6.7-5.9 14.99-.03c8.29 5.88 4.55 18.06 4.14 26.84-.42 8.92-16.87 17.6-16.87 17.6s2.11-9.69 1.53-16.44c-.6-6.98-3.08-9.83-4.55-9.63-1.47.2.45 5.19 1.33 9.81.87 4.63-.32 14.28-.32 14.28s-7.1-.65-12.25-.09c-3.58.39-9.93 2.54-12.51 2.66-2.04.09-5.72 2-5.72 2s1.94-5.24 1.36-11.27c-.49-5.02-5.68-19.82-5.55-28.08s6.29-16.34 13.74-20.34 12.93-5.38 17.66-2.39c6.28 3.98 3.04 15.08 3.04 15.08Z"
            style={{
              fill: '#007748',
            }}
          />
          <path
            d="M605.59 518.44s-12.35 42.66-13.28 63.75c-.93 21.08-22.03 33.05-31.96 52.52-9.93 19.47-16.36 56.81-16.36 56.81l-3.91-2.7s7.1-38.31 14.66-54.95c7.56-16.64 34.25-33.41 34.86-52.52.61-19.11 12.73-63.72 12.73-63.72l3.25.81Z"
            style={{
              fill: '#007748',
            }}
          />
          <path
            d="M610.47 594.26s-.53-8.09 12.31-2.18c10.78 4.96 17.64 17.06 13.13 25.4-4.35 8.05-7.34 10.23-8.5 11.58-1.16 1.35-2.47 4.92-2.47 4.92s-1.68-2.03-5.87-3.97c-4.53-2.1-25.73-10.83-30.71-23.7-5.9-15.23 2.74-18.95 10.1-18.15 6.85.75 12.01 6.09 12.01 6.09Zm-57.79-10.94s-1.58 37.79-5.73 53.2c-4.34 16.08-8.42 29.99-10.14 39.32-2.07 11.2-4.33 20.97-4.33 20.97l4.25-.13s2.46-12.28 4.09-21.28c1.64-9 7.37-31.1 10.23-40.51 2.86-9.41 4.5-52.38 4.5-52.38l-2.86.82Z"
            style={{
              fill: '#008551',
            }}
          />
          <path
            style={{
              fill: '#e49a54',
            }}
            d="m519.99 660.36 4.81 52.69h47.13l5.09-49.36 5.23-.06 1.11-14.49-69.01.37.37 10.82 5.27.03z"
          />
          <path
            d="M174 677.98s-15.03-31.32-20.04-66.39-8.77-115.24-8.77-115.24l6.26 2.51s12.53 61.38 16.28 95.2c3.76 33.82 12.53 82.67 12.53 82.67l-6.26 1.25Z"
            style={{
              fill: '#1b9339',
            }}
          />
          <path
            d="M187.16 665.75s-3.76-90.19 0-126.52 6.26-60.13 6.26-60.13h8.77s5.01 37.58 2.51 75.16c-2.51 37.58-10.02 113.99-10.02 113.99l-7.52-2.51Zm12.94 11.28s.15-.87.41-2.45c1.62-9.66 7.63-45.97 10.86-73.96 3.76-32.57 12.53-86.43 12.53-86.43l6.26 1.25s0 41.34-7.52 82.67c-7.52 41.34-15.03 82.67-15.03 82.67l-7.52-3.76Z"
            style={{
              fill: '#008551',
            }}
          />
          <path
            d="M188.94 662.39s-12.53-91.44-17.54-151.57c-5.01-60.13-12.53-105.22-12.53-105.22l7.59-.56s18.69 62.88 21.24 113.85c2.55 50.98 5.1 136.8 5.1 136.8l-3.87 6.7Z"
            style={{
              fill: '#4d6e56',
            }}
          />
          <path
            style={{
              fill: '#d28751',
            }}
            d="m156.02 662.88 1.85 50.17 58.03-1.36.81-49.32 5.72-4.63.09-11.32-71.32.38.38 11.19 4.44 4.89z"
          />
          <path
            d="M75.26 652.54s-15.03-31.32-20.04-66.39-8.77-115.24-8.77-115.24l6.26 2.51s12.53 61.38 16.28 95.2c3.76 33.82 12.53 82.67 12.53 82.67l-6.26 1.25Z"
            style={{
              fill: '#1b9339',
            }}
          />
          <path
            d="M88.42 674.73s-3.76-90.19 0-126.52 6.26-60.13 6.26-60.13h8.77s5.01 37.58 2.51 75.16c-2.51 37.58-10.02 113.99-10.02 113.99l-7.52-2.51Z"
            style={{
              fill: '#008551',
            }}
          />
          <path
            d="M83.4 702.48s.15-.87.41-2.45c1.62-9.66 7.63-45.97 10.86-73.96 3.76-32.57 12.53-86.43 12.53-86.43l6.26 1.25s0 41.34-7.52 82.67c-7.52 41.34-15.03 82.67-15.03 82.67l-7.52-3.76Zm.82-31.12s-12.53-91.44-17.54-151.57c-5.01-60.13-12.53-105.22-12.53-105.22l7.59-.56s18.69 62.88 21.24 113.85c2.55 50.98 5.1 136.8 5.1 136.8l-3.87 6.7Z"
            style={{
              fill: '#1b9339',
            }}
          />
          <path
            style={{
              fill: '#d28751',
            }}
            d="m54.28 662.88 1.86 50.17 58.02-1.36.82-49.32 5.72-4.63.09-11.32-71.32.38.38 11.19 4.43 4.89z"
          />
          <path
            d="M533.64 389.28c1.05 0 1.77 1.08 1.41 2.07-5.01 13.81-36.55 100.86-45.1 126.25-9.81 29.13-21.05 58.02-21.99 71.93-1.19 17.54 2.67 37.35 6.87 48.85 10.07 27.54 4.18 50.2 4.18 50.2l-8.71-.35s8.37-28.59-4.88-47.06c-13.25-18.48-43.57-52.99-62.4-62.75-18.82-9.76-42.47-24.86-41.08-24.86s1.85-4.94 1.85-4.94 27.37 20.74 40.27 26.67c12.9 5.93 59.61 45.67 59.61 45.67s-4.53-18.13-2.79-31.03c1.74-12.9 18.48-56.82 24.05-73.9 5.58-17.08 46.62-126.22 46.62-126.22s2.07-.51 2.08-.51Z"
            style={{
              fill: '#008551',
            }}
          />
          <path
            d="M520.06 395.82s0-32.65 24.89-41.62c24.89-8.98 33.65-3.34 37.13.41 7.41 7.98 9.39 13.47 9.39 13.47s-8.11-6.15-18.72-1.66-22.9 10.23-20.45 14.72c2.45 4.49 37.54-9.79 40.4-9.79s9.79 5.31 13.47 11.83c3.67 6.53 6.94 16.73 6.94 16.73s-15.91-8.98-32.65-8.57c-16.73.41-22.04 3.67-22.04 5.71s24.08-1.63 36.73 2.86c12.65 4.49 15.91 6.12 17.55 11.02 1.63 4.9 3.26 13.06 2.04 18.36-1.22 5.3-6.53 13.47-6.53 13.47s-1.63-11.83-19.59-21.63c-17.96-9.79-34.28-8.98-37.13-6.12-2.86 2.86 14.28 8.16 27.34 13.87 13.06 5.71 22.04 20 22.04 20l-14.28 11.43s-1.04-13.04-10.83-20.8c-9.79-7.75-23.04-9.81-25.9-7.77-2.86 2.04 15.1 11.83 20.81 17.96 5.71 6.12 7.75 12.24 7.75 12.24s-10.61 4.33-14.28 8.82-8.98 12.4-8.98 12.4-.23-8.2-9.21-14.32c-8.98-6.12-33.23-8.94-33.23-8.94s-5-9.19-.51-16.94c4.49-7.75 11.52-20.19 5.81-22.64-5.71-2.45-13.87 7.75-15.91 16.32-2.04 8.57-2.21 18.63-2.21 18.63l-25.54-14.55s4.9-15.1 15.1-20.81c10.2-5.71 18.36-9.39 17.14-11.83s-15.91-4.08-25.3 6.94-5.71 17.14-5.71 17.14-11.43-8.57-15.1-16.73-3.26-14.28-3.26-14.28 8.57-3.67 19.18-11.02 20-8.98 26.12-5.31 17.55 11.02 17.55 11.02Zm20.63 152.54s-2.44-9.76 3.83-13.25 10.11-3.14 16.38 1.39 9.41 21.26 17.43 28.24c8.02 6.97 16.38 15.69 15.69 24.4-.7 8.71-4.25 17.03-4.25 17.03s-3.79-6.31-8.66-7.88c-10.81-3.47-39.03-16.13-46.7-22.75-7.67-6.62-23.32-21.12-12.55-30.68 6.18-5.48 18.82 3.49 18.82 3.49Zm-83.57-33.58s-.7-10.81 13.25-8.72c13.94 2.09 24.4 14.99 17.08 27.54-7.32 12.55-14.34 17-16.09 20.48s-3.52 5.29-3.52 5.29-1.82-1.96-5.17-4.47c-5.24-3.93-30.85-15.54-32.59-28.79-1.74-13.25 7.87-16.21 14.49-17.26 6.62-1.05 12.55 5.93 12.55 5.93Z"
            style={{
              fill: '#008551',
            }}
          />
          <path
            d="M534.17 553.38s-22.52-8.36-40.76 9.88C475.17 581.5 448 638.41 448 638.41l-7.41-1.43s35.87-66.94 53.56-81.31c17.69-14.37 40.42-7.16 40.42-7.16l-.4 4.87Z"
            style={{
              fill: '#008551',
            }}
          />
          <path
            d="M410.7 416.12s-6.65-10.93-20.49-6.42c-13.84 4.5-13.92 22.75-17.1 34.95-3.23 12.37 15.58 31.26 15.58 31.26s1.25-14.16 4.92-23.14c3.79-9.29 8.4-12.13 10.32-11.23 1.93.9-2.83 6.9-6 12.86-3.17 5.96-5.65 19.67-5.65 19.67s9.98 2.14 16.8 5.1c4.74 2.06 12.5 7.71 15.98 8.97 2.75.99 6.97 5.17 6.97 5.17s-.42-7.99 2.95-15.99c2.8-6.66 16.22-24.69 19.56-36.04 3.34-11.36-1.64-25.03-10.12-33.68-8.49-8.65-15.39-12.87-23.14-10.79-10.29 2.76-10.58 19.33-10.58 19.33Z"
            style={{
              fill: '#007346',
            }}
          />
          <path
            d="M421.17 420.04s-1.3 63.62-9.01 92.85c-7.71 29.24 16.05 54.6 21.33 85.46 5.28 30.86-1.84 84.67-1.84 84.67l6.5-2.03s6.62-55.42 3.37-81.41c-3.25-25.99-32.6-60.3-25.29-86.69 7.31-26.39 9.75-92.58 9.75-92.58l-4.79-.27Z"
            style={{
              fill: '#007346',
            }}
          />
          <path
            d="M373.98 542.86s.76-11.6-17.64-3.12c-15.44 7.11-25.28 24.45-18.82 36.39 6.23 11.53 10.51 14.66 12.18 16.59 1.67 1.93 3.54 7.05 3.54 7.05s2.41-2.91 8.41-5.69c6.49-3.01 36.86-15.51 44-33.95 8.45-21.81-3.93-27.15-14.47-26-9.81 1.07-17.21 8.73-17.21 8.73Zm82.79-15.67s2.26 54.14 8.21 76.21c6.21 23.04 12.06 42.96 14.53 56.33 2.97 16.05 6.21 30.04 6.21 30.04l-6.08-.19s-3.52-17.59-5.86-30.49c-2.34-12.9-10.55-44.56-14.66-58.04-4.1-13.48-6.45-75.04-6.45-75.04l4.1 1.17Z"
            style={{
              fill: '#008551',
            }}
          />
          <path
            style={{
              fill: '#ef7723',
            }}
            d="m503.6 637.56-6.88 75.49h-67.53l-7.29-70.72-7.5-.08-1.58-20.76 98.86.53-.53 15.5-7.55.04z"
          />
          <path
            style={{
              fill: '#284634',
            }}
            d="M-132.98 704.2h970.69v103.47h-970.69z"
          />
          <path
            style={{
              fill: '#a0d6e8',
            }}
            d="m811.74 157.67-925 294.32.68-21.52 924.99-294.31-.67 21.51z"
          />
        </g>
        <path
          style={{
            fill: '#feca1d',
          }}
          d="m-144.26 92.1-11.96 186.88 941.59 1.14-11.98-188.06-917.65.04z"
        />
        <path
          id="ENVIRONMENT_BACKGROUND"
          style={{
            fill: '#95a39c',
          }}
          d="m-181.56 908.54 2287.52-3.83-23.38 321.06-2231.94 147.4-32.2-464.63z"
        />
        <path
          style={{
            fill: '#284634',
          }}
          d="m1510.89 703.08 19.57-.28v12.02h-19.85l.28-11.74zm1.12-81.94 19.57-.28v12.02h-19.85l.28-11.74z"
        />
        <path
          style={{
            fill: '#e0be86',
          }}
          d="m1501.92 610.55 12.3.51v114.37l-12.82.51.52-115.39z"
        />
        <path
          style={{
            fill: '#284634',
          }}
          d="m1579.74 704.14-19.57-.28v12.03h19.85l-.28-11.75zm-1.12-81.93-19.57-.28v12.02h19.85l-.28-11.74z"
        />
        <path
          style={{
            fill: '#e0be86',
          }}
          d="m1588.71 611.61-12.3.52V726.5l12.82.51-.52-115.4z"
        />
        <path
          style={{
            fill: '#fcf6e7',
          }}
          d="m1715.6 272.98-.36 48.77 59.07-.51.63-49.87-59.34 1.61z"
        />
        <path
          style={{
            fill: '#2d2b40',
          }}
          d="m1725.9 286.26 2.9 4.19 3.58-2.13.08 24.84 6.78.23.3-33.99-5.94-.23-7.7 7.09zm18.14 0 2.89 4.19 3.59-2.13.07 24.84 6.78.23.31-33.99-5.95-.23-7.69 7.09z"
        />
        <path
          style={{
            fill: '#644130',
          }}
          d="m1209.85 815.99.71-122.18 4.35-.31 4.04 121.77-9.1.72z"
        />
        <path
          d="m1166.14 798.59 3.53 123.41 82.33 1.24 11-118.61s-8.33-1.4-31.99-1.99c-23.66-.61-64.87-4.05-64.87-4.05Z"
          style={{
            fill: '#e2bcc2',
          }}
        />
        <path
          d="M1210.83 654.95c-33.52-1.53-62.42 18.73-64.57 48.43-1.98 27.58 18.52 52.27 41.34 54.97 22.79 2.67 46.17 1.98 62.55-4.17 19.88-7.46 32.64-27.33 27.29-52.82-5.39-25.49-22.21-44.37-66.6-46.41Z"
          style={{
            fill: '#95c11f',
          }}
        />
        <path
          style={{
            fill: '#644130',
          }}
          d="m765.31 820.09.71-122.17 7.81.26 4.04 121.77-12.56.14z"
        />
        <path
          d="m725.06 803.27 3.04 123.54 84.38-.66 9.43-116.84s-8.33-1.4-31.99-1.99c-23.66-.61-64.87-4.05-64.87-4.05Z"
          style={{
            fill: '#e2bcc2',
          }}
        />
        <path
          d="M768.5 654.59c-33.52-1.52-62.42 18.73-64.57 48.43-1.98 27.58 18.52 52.27 41.34 54.97 22.79 2.67 46.17 1.98 62.55-4.17 19.88-7.46 32.64-27.33 27.28-52.82-5.39-25.49-22.21-44.37-66.6-46.41Z"
          style={{
            fill: '#009b3e',
          }}
        />
      </g>
    </svg>
  )
}

export default TeenageRoom
